module.exports = __webpack_public_path__ + "static/img/img_y.3d264210.png";